import history from "../../history.js";

import { translations, mapCountryList } from "../index";

const changeUrlwithLanguageChange = (langCode, entryState) => {
  let newUrl = history.location.pathname;

  let logicOf404 =
    newUrl.split("/")[newUrl.split("/").length - 1] !== "" &&
    newUrl.split("/")[newUrl.split("/").length - 2] !== ""
      ? true
      : false;

  if (logicOf404 || newUrl.split("/").length < 3) {
    if (history.location.pathname.includes("preview")) {
      if (mapCountryList.some(code => newUrl.includes(`/${code}/`))) {
        mapCountryList
          .filter(code => {
            if (newUrl.includes(`/${code}/`) && code !== "en") {
              return true;
            } else {
              return false;
            }
          })
          .map(code => (newUrl = newUrl.replace(`/${code}/`, "/")));
      }
      newUrl = newUrl.replace("preview", `preview/${langCode}`);
    } else {
      if (mapCountryList.some(code => newUrl.includes(`/${code}/`))) {
        mapCountryList
          .filter(code => {
            if (newUrl.includes(`/${code}/`)) {
              return true;
            } else {
              return false;
            }
          })
          .forEach(code => (newUrl = newUrl.replace(`/${code}/`, "/")));
      }
      newUrl = `/${langCode}${newUrl}`;
    }
    if (newUrl.includes("/en/")) {
      newUrl = newUrl.replace("/en/", "/");
    }

    history.push(encodeURI(newUrl));
  } else {
    history.push("/");
  }
};

export default changeUrlwithLanguageChange;
